export default {
    relationshipRules: state => state.relationshipRules
}
